
  
function getParameterByName(name, url) 
	{
    	if (!url) 
          url = window.location.href;
      
    	name = name.replace(/[\[\]]/g, "\\$&");
    	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
        results = regex.exec(url);
    	if (!results)
          return null;
    	if (!results[2])
          return '';
    	return decodeURIComponent(results[2].replace(/\+/g, " "));
	}
    
      function setupBrochureLink()
      {

        var loc = "";
      	var p = getParameterByName('p');
        
        switch(p) 
        {
    		case 'job':
        	loc = "Dri-Dek_Bar_Flooring_Brochure.pdf?v=1719595616";
        	break;
    
           case "wet-floors":
            loc = "Dri-Dek_for_Wet_Floors.pdf?10228561519415839273";
			break;
            
           case "pets":
            loc = "Dri-Dek_Kennel_Liners.pdf?5332806628045326480";
			break;
            
           case "marine":
            loc = "Dri-Dek_Marine.pdf?2617656038331705409";
			break;
            
           case "truck":
            loc = "Dri-Dek_for_Trucks.pdf";
			break;
            
           case "home-patio":
            loc = "Dri-Dek_for_Patios_2_pages.pdf";
			break;
            
           case "bar":
            loc = "Dri-Dek_Bar_Flooring_Brochure.pdf?v=1719593551";
			break;
            
           case "bed":
            loc = "Dri-Dek_Pickup_Truck_Bed_Liner.pdf";
			break;
            
            case "lab":
            loc = "Dri-Dek_for_the_Lab.pdf";
			break;
            
		   default:
        	loc = "General_Use_Dri-Dek_Brochure_2_Pages.pdf";
		}
                
        document.getElementById("appLink").href = "https://cdn.shopify.com/s/files/1/0982/0484/files/" + loc;  		
  	  }

		if (window.addEventListener)
        {
          	//alert('adding load listener');
            window.addEventListener('load', setupBrochureLink, false);
        }
      	else if (window.attachEvent) // only happens in <= IE8
        {          
          //alert('adding onload listenerm for IE');
          window.attachEvent('onload', setupBrochureLink);
        }
      
   